const hideSensetive = (string, hide = false) => {
  if (typeof string !== "string" || string.length < 4) {
    return string;
  }

  return hide ? "*****" + string.slice(-4) : string;
};

export default hideSensetive;
